// 9fbef606107a605d69c0edbcd8029e5d 
import { connect } from 'react-redux';
import { getCurrency,getIsPDPPriceIframeEnabled } from './PriceCurrency.selectors';
import BAGPAGE_SELECTORS from '../../../../features/CnC/BagPage/container/BagPage.selectors';
import PriceCurrencyView from '../views';

export const mapStateToProps = state => {
  return {
    currency: getCurrency(state),
    currencySymbol: BAGPAGE_SELECTORS.getCurrentCurrency(state),
    isPDPPriceIframeEnabled:getIsPDPPriceIframeEnabled(state)
  };
};

export default connect(mapStateToProps)(PriceCurrencyView);
